import {KeyboardEvent, MouseEvent, useCallback, useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {ViewType} from "../../../../view_type/ViewType";
import {MapOfferPreview} from "../../../components/map_offer/MapOfferPreview";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar} from "../../../map/types/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: MouseEvent | KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const {viewType, isModalOpen, onModalClose, offerList, appliedOffers, favouriteOffers} = props;

    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    const handleSetOfferId = (offerId: number | null) => {
        setCurrentOfferId(offerId);
    };

    useEffect(() => {
        if (!isInitialized) {
            setIsInitialized(true);
        }
    }, [isInitialized]);

    useEffect(() => {
        if (isModalOpen && !isInitialized) {
            setIsInitialized(true);
        }
    }, [isModalOpen, isInitialized]);

    if (!isInitialized) {
        return (
            <div className={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div className={css({position: "relative"})}>
            <Modal
                fullScreen
                isOpen={isModalOpen}
                onModalClose={onModalClose}
                contentStyle={{
                    display: "flex",
                    alignItems: "normal",
                    justifyContent: "normal",
                    flexDirection: "column"
                }}
            >
                {!isInitialized ? (
                    <div className={viewLoaderHolder}>
                        <Loader />
                    </div>
                ) : (
                    <div className={mapHolderSection}>
                        <Button className={mapModalButton} onClick={onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                            Lista
                        </Button>

                        <div className={mapHolder}>
                            <MapSize fullWidth={!currentOfferId}>
                                <OSMapForOffers
                                    transportRoutes={transportRoutes}
                                    viewType={viewType}
                                    onMarkerClick={onMarkerClick}
                                    offers={offerList}
                                    favouriteOffers={favouriteOffers}
                                    appliedOffers={appliedOffers}
                                />
                            </MapSize>

                            {currentOfferId && (
                                <MapOfferPreview
                                    offerId={currentOfferId}
                                    handleSetOfferId={handleSetOfferId}
                                    onClose={onOfferSidebarClose}
                                    latestQuery={{}}
                                    isOpen={!!currentOfferId}
                                />
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh"
});

const mapHolderSection = css({
    position: "relative",
    flexGrow: 1,
    flexShrink: 1
});

const mapHolder = css({
    display: "flex",
    flexDirection: "row",
    height: "100%",
    width: "100%"
});

const mapModalButton = css({
    position: "absolute",
    top: "2.5rem",
    left: "2.5rem",
    zIndex: 1
});
import {KeyboardEvent, MouseEvent, useCallback, useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {ViewType} from "../../../../view_type/ViewType";
import {MapOfferPreview} from "../../../components/map_offer/MapOfferPreview";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar} from "../../../map/types/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: MouseEvent | KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const {viewType, isModalOpen, onModalClose, offerList, appliedOffers, favouriteOffers} = props;

    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    const handleSetOfferId = (offerId: number | null) => {
        setCurrentOfferId(offerId);
    };

    useEffect(() => {
        if (!isInitialized) {
            setIsInitialized(true);
        }
    }, [isInitialized]);

    useEffect(() => {
        if (isModalOpen && !isInitialized) {
            setIsInitialized(true);
        }
    }, [isModalOpen, isInitialized]);

    if (!isInitialized) {
        return (
            <div className={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div className={css({position: "relative"})}>
            <Modal
                fullScreen
                isOpen={isModalOpen}
                onModalClose={onModalClose}
                contentStyle={{
                    display: "flex",
                    alignItems: "normal",
                    justifyContent: "normal",
                    flexDirection: "column"
                }}
            >
                {!isInitialized ? (
                    <div className={viewLoaderHolder}>
                        <Loader />
                    </div>
                ) : (
                    <div className={mapHolderSection}>
                        <Button className={mapModalButton} onClick={onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                            Lista
                        </Button>

                        <div className={mapHolder}>
                            <MapSize fullWidth={!currentOfferId}>
                                <OSMapForOffers
                                    transportRoutes={transportRoutes}
                                    viewType={viewType}
                                    onMarkerClick={onMarkerClick}
                                    offers={offerList}
                                    favouriteOffers={favouriteOffers}
                                    appliedOffers={appliedOffers}
                                />
                            </MapSize>

                            {currentOfferId && (
                                <MapOfferPreview
                                    offerId={currentOfferId}
                                    handleSetOfferId={handleSetOfferId}
                                    onClose={onOfferSidebarClose}
                                    latestQuery={{}}
                                    isOpen={!!currentOfferId}
                                />
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh"
});

const mapHolderSection = css({
    position: "relative",
    flexGrow: 1,
    flexShrink: 1
});

const mapHolder = css({
    display: "flex",
    flexDirection: "row",
    height: "100%",
    width: "100%"
});

const mapModalButton = css({
    position: "absolute",
    top: "2.5rem",
    left: "2.5rem",
    zIndex: 1
});
